// extracted by mini-css-extract-plugin
module.exports = {"reports-carousel":"reports-carousel___CJxtb","add-report-card":"add-report-card___2vmmA","circle":"circle___PjcMY","plus-icon":"plus-icon___3m3jD"};